import React, { Fragment, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { redefinirSenha as redefinirSenhaService } from '../../services/authService';

const Forgot: React.FC = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('As senhas não conferem');
      return;
    }
    try {
      await redefinirSenhaService(token, password);
      navigate('/login');
    } catch (err) {
      console.error(err);
      setError('Erro ao redefinir senha');
    }
  };

  return (
    <Fragment>
      <div className="main-wrap">
              <div className="nav-header bg-transparent shadow-none border-0">
                <div className="nav-top w-100">
                  <Link to="/" className='ms-5 mt-5'>
                    <img src="/assets/images/logo-inplay.png" alt="InPlay Logo" className="nav-logo" style={{ height: 60 }} />
                  </Link>
                  <button className="nav-menu me-0 ms-auto"></button>
                  <Link to="/login" className="header-btn d-none d-lg-block bg-dark fw-500 text-white font-xsss p-3 ms-auto w100 text-center lh-20 rounded-xl">Login</Link>
                  <Link to="/register" className="header-btn d-none d-lg-block bg-current fw-500 text-white font-xsss p-3 ms-2 w100 text-center lh-20 rounded-xl">Cadastrar</Link>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-xl-5 d-none d-xl-block p-0 vh-100 bg-image-contain bg-no-repeat bg-primary"
                  style={{
                    backgroundImage: `url("assets/images/login-banner.png")`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain'
                  }}
                ></div>
                <div className="col-xl-7 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
            <div className="card shadow-none border-0 ms-auto me-auto login-card">
              <div className="card-body rounded-0 text-left">
                <h2 className="fw-700 display1-size display2-md-size mb-3">Redefinir senha</h2>
                <form onSubmit={handleSubmit}>
                  <div className="form-group icon-input mb-3">
                    <input
                      type="password"
                      className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"
                      placeholder="Nova senha"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <i className="font-sm ti-lock text-grey-500 pe-0"></i>
                  </div>
                  <div className="form-group icon-input mb-3">
                    <input
                      type="password"
                      className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"
                      placeholder="Confirme a nova senha"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                    <i className="font-sm ti-lock text-grey-500 pe-0"></i>
                  </div>
                  {error && <p className="font-xsss text-danger mb-3">{error}</p>}
                  <div className="form-group mb-1">
                    <button type="submit" className="btn btn-primary form-control text-center style2-input fw-600 border-0 p-0 fs-5">
                      Alterar senha
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Forgot;
